import { CheckIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import Checkbox from 'react-custom-checkbox';

const RoundCheckBox = ({
  size = 1,
  value,
  previousValue = null,
  borderWidth = 0.15,
  strokeWidth = 5,
  disabled = false,
  changeFieldValue = () => {},
}) => {
  const getBackgroundColor = () => {
    if (previousValue === null) {
      return 'bg-[#66B2FF]';
    }
    return previousValue === value ? 'bg-[#C0C0C0]' : 'bg-[#66B2FF]';
  };
  const getBorderColor = () => {
    if (previousValue === null) {
      return '#66B2FF';
    }
    return previousValue === value ? '#C0C0C0' : '#66B2FF';
  };
  return (
    <>
      <Checkbox
        style={{ width: `${size}rem`, height: `${size}rem` }}
        className={classNames(
          'cursor-pointer',
          value ? getBackgroundColor(value, previousValue) : null,
        )}
        borderWidth={`${borderWidth}rem`}
        icon={
          <CheckIcon
            style={{ strokeWidth, width: `${size}rem`, height: `${size}rem` }}
            className="text-white font-bold"
          />
        }
        borderColor={getBorderColor(value, previousValue)}
        borderRadius={100}
        disabled={disabled}
        onChange={(val) => changeFieldValue(val)}
        checked={value}
      />
    </>
  );
};

export default RoundCheckBox;
